import { BaseModel } from '../../../global/models';

export interface Faq extends BaseModel {
  question: string;
  answer: string;
  category: FaqCategory;
}

export enum FaqCategory {
  FILES = 'Archivos',
  BONUS = 'Bonos',
  CONFIGURATION = 'Configuración',
  SHIPMENTS = 'Envíos',
  MANAGEMENT = 'Gestión'
}
